import { SafeResourceUrl } from '@angular/platform-browser';

export class VideoSource {

  mimeType: string;
  filePath: string;
  safeUrl: SafeResourceUrl;
  fileName: string;
  thumbPath: string;

  constructor(videoSrc?: Partial<VideoSource>) {
    Object.assign(this, videoSrc);

    if (videoSrc.mimeType.includes('quicktime')) {
      this.mimeType = 'video/mp4';
    }
    if (this.filePath.includes('http')) {
      const idOf = this.filePath.lastIndexOf('.');
      this.thumbPath = this.filePath.substring(0, idOf) + '.jpg';
    }
  }
}
